// Persistent user preference: the fullscreen orange act-as frame
// (ImpersonationFrame) can be switched off from the admin menu. In-memory
// value is the source of truth (snapshot-stable for useSyncExternalStore);
// localStorage only persists the choice across reloads. Module store — same
// pattern as actAsStore — keeps the menu switch and the frame in sync
// without another provider.
const FRAME_OFF_KEY = "actAsFrameOff";

function readInitial(): boolean {
  try {
    return localStorage.getItem(FRAME_OFF_KEY) !== "true";
  } catch {
    return true;
  }
}

let frameEnabled = readInitial();

const listeners = new Set<() => void>();

export function isActAsFrameEnabled(): boolean {
  return frameEnabled;
}

export function setActAsFrameEnabled(enabled: boolean): void {
  frameEnabled = enabled;
  try {
    if (enabled) {
      localStorage.removeItem(FRAME_OFF_KEY);
    } else {
      localStorage.setItem(FRAME_OFF_KEY, "true");
    }
  } catch {
    // Storage unavailable — the toggle still works for this page lifetime,
    // the preference just won't survive a reload.
  }
  listeners.forEach((listener) => listener());
}

export function subscribeActAsFrame(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
